import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

import { BarRatingModule } from 'ngx-bar-rating';
import { NgxHmCarouselComponent, NgxHmCarouselItemDirective, NgxHmCarouselDynamicDirective } from 'ngx-hm-carousel';
import { PonchoUIModule } from '@poncho/ui';
import { PopoverComponent } from '@shared/components/popover/popover.component';
import { TimerComponent } from '@shared/components/timer/timer.component';
import { BirthdayAnimationComponent } from '@shared/components/birthday-animation/birthday-animation.component';
import { FeedbackComponent } from '@shared/components/feedback/feedback.component';
import { FeedbackDialogComponent } from '@shared/components/feedback/feedback-dialog/feedback-dialog.component';
import { FeedbackReviewDialogComponent } from '@shared/components/feedback/feedback-review-dialog/feedback-review-dialog.component';
import { NotificationBannerComponent } from '@shared/components/notification-banner/notification-banner.component';
import { SpriteIconsComponent } from '@shared/components/sprite-icons/sprite-icons.component';
import { ImageSliderComponent } from '@shared/components/image-slider/image-slider.component';
import { CustomizationComponent } from '@shared/components/customization/customization.component';
import { GroupCustomizationComponent } from '@shared/components/customization/group-customization/group-customization.component';
import { BannerComponent } from '@shared/components/banner-mojo/banner-mojo.component';
import { CartNotificationComponent } from '@shared/components/cart-notification/cart-notification.component';
import { SelectorComponent } from '@shared/components/dummy-template/selector/selector.component';
import { CardImageLayoutComponent } from '@shared/components/dummy-template/card-image-layout/card-image-layout.component';
import { MenuFilterComponent } from '@shared/components/menu-filter/menu-filter.component';
import { BottomNavigationComponent } from '@shared/components/bottom-navigation/bottom-navigation.component';
import { MultiBrandCartViewComponent } from '@shared/components/multi-brand-cart-view/multi-brand-cart-view.component';
import { ProductListComponent } from '@shared/components/product-list/product-list.component';
import { PluginVideoComponent } from '@shared/components/plugin-video/plugin-video.component';

import { HeaderComponent } from '@core/components/header/header.component';
import { FooterComponent } from '@core/components/footer/footer.component';
import { BaseComponent } from '@core/components/base/base.component';
import { OutletChangeErrorComponent } from '@core/components/header/components/outlet-change-error/outlet-change-error.component';
import { AnnouncementComponent } from '@core/components/announcement/announcement.component';
import { CartDropdownComponent } from '@core/components/header/components/cart-dropdown/cart-dropdown.component';
import { CrossBrandOrderResetComponent } from '@core/components/header/components/cross-brand-order-reset/cross-brand-order-reset.component';

import { FeatureToggleDirective } from '@shared/directives/feature-toggle.directive';
import { GooglePlaceDirective } from '@shared/directives/google-place.directive';
import { DeferImageLoadDirective } from '@shared/directives/defer-image-load.directive';

import { BrandProductFilterPipe } from '@shared/pipes/brand-product-filter.pipe';
import { CategoryFilterPipe } from '@shared/pipes/category-filter.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SmartBannerComponent } from '@core/components/header/components/smart-banner/smart-banner.component';
import { CartViewItemErrorComponent } from '@shared/components/cart-view-item-error/cart-view-item-error.component';
import { BottomStripCarouselComponent } from '@app/shared/components/bottom-strip-carousel/bottom-strip-carousel.component';
import { BottomStripComponent } from '@app/shared/components/bottom-strip/bottom-strip.component';
import { HeaderLoaderComponent } from '@app/core/components/header/components/header-loader/header-loader.component';
import { DeliverySupportComponent } from '@app/shared/components/delivery-support/delivery-support.component';

import { RupeePipe } from '@app/shared/pipes/rupee.pipe';
import { AbsPipe } from '@app/shared/pipes/abs.pipe';
import { SafePipe } from '@shared/pipes/safe.pipe';
import { CustomisationGroupPipe } from '@app/shared/pipes/customisation-group.pipe';
// import { UtitlityPipe } from '@app/shared/pipes/utility.pipe';
import { TruncatePipe } from '@app/shared/pipes/truncate.pipe';
import { OnboardingModule } from '@app/modules/onboarding/onboarding.module';
import { BrandStatePipe } from '@app/shared/pipes/brand-state.pipe';
import { TypeofPipe } from '@app/shared/pipes/typeof.pipe';
import { OutletStatusStripComponent } from '@app/shared/components/outlet-status-strip/outlet-status-strip.component';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatMenuModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatSnackBarModule,
        FormsModule,
        ReactiveFormsModule,
        BarRatingModule,
        MatDividerModule,
        NgxHmCarouselComponent,
        NgxHmCarouselItemDirective,
        NgxHmCarouselDynamicDirective,
        MatCheckboxModule,
        MatRadioModule,
        MatTooltipModule,
        PonchoUIModule,
        MatExpansionModule,
        DragDropModule,
        RouterModule,
        OnboardingModule,
        FeedbackComponent,
        PopoverComponent,
        TimerComponent,
        BirthdayAnimationComponent,
        FeedbackDialogComponent,
        NotificationBannerComponent,
        OutletStatusStripComponent,
        SpriteIconsComponent,
        ImageSliderComponent,
        GooglePlaceDirective,
        DeferImageLoadDirective,
        FeatureToggleDirective,
        BannerComponent,
        HeaderComponent,
        HeaderLoaderComponent,
        FooterComponent,
        BaseComponent,
        OutletChangeErrorComponent,
        AnnouncementComponent,
        CartDropdownComponent,
        MenuFilterComponent,
        CustomizationComponent,
        GroupCustomizationComponent,
        BrandProductFilterPipe,
        BrandStatePipe,
        TypeofPipe,
        CategoryFilterPipe,
        CartNotificationComponent,
        BottomStripCarouselComponent,
        BottomStripComponent,
        MultiBrandCartViewComponent,
        BottomNavigationComponent,
        CrossBrandOrderResetComponent,
        SelectorComponent,
        CardImageLayoutComponent,
        ProductListComponent,
        PluginVideoComponent,
        FeedbackReviewDialogComponent,
        SmartBannerComponent,
        CartViewItemErrorComponent,
        DeliverySupportComponent,
        RupeePipe,
        AbsPipe,
        SafePipe,
        CustomisationGroupPipe,
        // UtitlityPipe,
        TruncatePipe
    ],
    exports: [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatMenuModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatSnackBarModule,
        MatDividerModule,
        DragDropModule,
        FormsModule,
        ReactiveFormsModule,
        PonchoUIModule,
        MatCheckboxModule,
        MatRadioModule,
        PopoverComponent,
        TimerComponent,
        BirthdayAnimationComponent,
        FeedbackComponent,
        NotificationBannerComponent,
        OutletStatusStripComponent,
        BottomStripCarouselComponent,
        BottomStripComponent,
        SpriteIconsComponent,
        ImageSliderComponent,
        GooglePlaceDirective,
        DeferImageLoadDirective,
        FeatureToggleDirective,
        BannerComponent,
        HeaderComponent,
        FooterComponent,
        CustomizationComponent,
        GroupCustomizationComponent,
        BrandProductFilterPipe,
        BrandStatePipe,
        TypeofPipe,
        CategoryFilterPipe,
        CartNotificationComponent,
        MatExpansionModule,
        MultiBrandCartViewComponent,
        BottomNavigationComponent,
        SelectorComponent,
        CardImageLayoutComponent,
        ProductListComponent,
        PluginVideoComponent,
        CartViewItemErrorComponent,
        DeliverySupportComponent,
        RupeePipe,
        AbsPipe,
        SafePipe,
        CustomisationGroupPipe,
        // UtitlityPipe,
        TruncatePipe
    ],
    providers: [
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: { hasBackdrop: true, autoFocus: true }
        },
        { provide: MatBottomSheetRef, useValue: {} },
        { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
        HeaderComponent
    ]
})
export class HomeModule {}
